import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import { Theme, whiteTheme } from '..'

export const WhiteThemeContext = createContext(false)

export default function WhiteTheme({ children, as = 'div', ...props }) {
  return (
    <Theme as={as} theme="day" {...props} transparent>
      <div className={whiteTheme}>
        <WhiteThemeContext.Provider value>{children}</WhiteThemeContext.Provider>
      </div>
    </Theme>
  )
}

WhiteTheme.propTypes = {
  /** Enclosing tag name. */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),

  /** Any typography components within this component's children will have white text. */
  children: PropTypes.node.isRequired,
}
